﻿export default class Card {
    constructor(id) {
        this.id = id;
        this.number = "2"
        this.value = "2"
        this.suit = "s";
        this.pile = "main";
        this.pilez = 0;
        this.showfront = false;
        this.owner = null;
    }
}